import { useEffect, useRef } from "react";

/**
 * Method is a hook that use inside useEffect hook, and help the code to not be executed on first render
 * @param callback
 * @param dependencies
 */
export const useUpdateEffect = (callback, dependencies = []) => {
  const isMounted = useRef(false);

  useEffect(() => {
    if (isMounted.current) {
      callback();
    } else {
      isMounted.current = true;
    }
    // eslint-disable-next-line
  }, dependencies);
};
